import React from "react";
import fadlElzikrData from "../FadlElzikrData";
import AzkarListHeader from "../../../AzkarList/AzkarListHeader";

function FadleZikr() {
  return (
    <>
      <AzkarListHeader List={fadlElzikrData.List} />
    </>
  );
}

export default FadleZikr;
